import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { UploadImg } from "../../../Common/Controls/Controls";
import { infoSource, requestAxios } from "../../../../util/util";
import AppContext from "../../../../Context/AppContext";
import { KTSVG, toAbsoluteUrl } from "../../../../helpers";
import "./Archivos.css";

const Archivos = ({ currentDemanda, currentEtapa }) => {
  const defaultIcons = [
    { extension: "pdf", url: toAbsoluteUrl("/img/Icons/PDF.png") },
    { extension: "doc", url: toAbsoluteUrl("/img/Icons/Word.png") },
    { extension: "docx", url: toAbsoluteUrl("/img/Icons/Word.png") },
    { extension: "xls", url: toAbsoluteUrl("/img/Icons/Excel.png") },
    { extension: "xlsx", url: toAbsoluteUrl("/img/Icons/Excel.png") },
  ];
  const { checkUserSession, changeLoading, updateGestorNombre } =
    useContext(AppContext);
  const infoUs = checkUserSession();
  const [files, setFiles] = useState([]);
  const [reload, setReload] = useState(true);
  const [archivosActuales, setArchivosActuales] = useState([]);
  const [currentRow, setCurrentRow] = useState({
    GesRazonSocial: infoUs.GesRazonSocial,
  });

  useEffect(() => {
    loadinfo();
  }, []);
  async function loadinfo() {
    changeLoading(true);
    const currR = await infoSource.Demandas.GetArchivosDemanda(
      infoUs,
      currentDemanda.AsigDemandaId,
      currentEtapa.EtapaId
    );
    const newList = currR.map((item) => ({
      base64: `data:${item.Tipo};base64,${item.Archivo}`,
      type: item.Tipo,
      extension: item.Extension,
      name: item.NombreArchivo,
      archivoId: item.ArchivoId,
      eliminar:item.eliminar
    }));
    await setArchivosActuales(newList);
    changeLoading(false);
  }
  function showfile(files) {
    files.map((item) => {
      const nameArray = item.name.split(".");
      const ext = String(nameArray[nameArray.length - 1]).toLocaleLowerCase();
      item.extension = ext;
    });
    setFiles(files);
  }
  async function saveData() {
    changeLoading(true);
    const PostObj = {
      AsigDemandaId: currentDemanda.AsigDemandaId,
      EtapaId: currentEtapa.EtapaId,
      archivos: files.map((item) => ({
        base64: item.base64,
        NombreArchivo: item.name,
        Extension: item.extension,
        Tipo: item.type,
      })),
    };
    const { error, data } = await requestAxios({
      url: `Demandas/IArchivoEtapaProcesal`,
      method: "post",
      token: infoUs.bearer_token,
      data: PostObj,
    });
    if (error === "") {
      setReload(false);
      changeLoading(false);
      const MySwal = withReactContent(Swal);
      await MySwal.fire({
        title: <strong>Hecho!</strong>,
        html: <i>Guardado con éxito!</i>,
        icon: "success",
      });
      setReload(true);
      setFiles([]);
      loadinfo();
    } else {
      alert("Error, try again");
    }
    changeLoading(false);
    loadinfo()
  }
  async function Removefile(item) {
    const MySwal = withReactContent(Swal);
    await MySwal.fire({
      title: (
        <strong>Esta Seguro que desea eliminar el archivo {item.name}?</strong>
      ),
      html: (
        <div
          style={{
            backgroundColor: "red",
            color: "black",
            padding: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
          }}
        >
          El archivo no se podrá recuperar!
        </div>
      ),
      icon: "error",
      confirmButtonText: "Si, Eliminar",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "red",
    }).then(async (result) => {
      if (result.value) {
        const { error, data } = await requestAxios({
          url: `Demandas/RArchivoEtapaProcesal?ArchivoId=${item.archivoId}`,
          method: "delete",
          token: infoUs.bearer_token,
        });
        if (error === "") {
          changeLoading(false);
          const MySwal = withReactContent(Swal);
          await MySwal.fire({
            title: <strong>Hecho!</strong>,
            html: <i>Eliminado con éxito!</i>,
            icon: "success",
          });
          loadinfo();
        } else {
          alert("Error, try again");
        }
        changeLoading(false);
      }
    });
  }

  function generaDescargablePdf(data, name) {
    var arrdata = data.split(",");
    var fileBase64 = arrdata[1];
    var mime = arrdata[0].replace("data:", "").replace(";base64", "");
    var arrBuffer = base64ToArrayBuffer(fileBase64);
    var newBlob = new Blob([arrBuffer], { type: mime });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }
    var data = window.URL.createObjectURL(newBlob);

    var link = document.createElement("a");
    document.body.appendChild(link); //required in FF, optional for Chrome
    link.href = data;
    link.download = name;
    link.click();
    window.URL.revokeObjectURL(data);
    link.remove();
  }
  function base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  return (
    <>
      <div className="Archivos__container">
        <div className="Archivos_nuevosArchivos Archivos_box">
          <h1>Archivos por Agregar</h1>
          {reload == true && (
            <UploadImg
              files={files}
              setFiles={showfile}
              types={[
                "png",
                "jpg",
                "jpeg",
                "pdf",
                "doc",
                "docx",
                "xls",
                "xlsx",
              ]}
              multiple={true}
            />
          )}
          <div className="PreviewFiles__container">
            {files.map((file, i) => {
              const it = defaultIcons.find(
                (x) => x.extension === file.extension
              );
              return (
                <div className="PreviewFiles__item">
                  <div
                    key={i}
                    className="ArchivoPreview"
                    style={{
                      backgroundImage: `url(${
                        it == null ? file.base64 : it.url
                      })`,
                    }}
                  />
                  {file.name}
                </div>
              );
            })}
            <br />
          </div>
        </div>
        <div className="Archivos_viejosArchivos Archivos_box">
          <h1>Archivos Actuales</h1>
          <div className="ArchivosActuales__container">
            {archivosActuales.map((item, i) => {
              const it = defaultIcons.find(
                (x) => x.extension === item.extension
              );
              return (
                <div>
                  <div
                    key={`ArchivosActuales__item${i}`}
                    className="ArchivosActuales__item"
                  >
                    <div
                      key={i}
                      className="ArchivoPreview"
                      style={{
                        backgroundImage: `url(${
                          it == null ? item.base64 : it.url
                        })`,
                      }}
                    />
                    {item.name}
                  </div>

                  <div className="eliminarArchivo__container">
                    {item.eliminar==true && (
                      <button
                        className="btnEliminarArchivo"
                        onClick={() => Removefile(item)}
                      >
                        <img src={toAbsoluteUrl("/img/Icons/Remove.svg")} />
                      </button>
                    )}
                    <button
                      className="btnEliminarArchivo"
                      onClick={() =>
                        generaDescargablePdf(item.base64, item.name)
                      }
                    >
                      <img src={toAbsoluteUrl("/img/Icons/Download.svg")} />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <button className="miPerfil__btnGuardar" onClick={() => saveData()}>
        Guardar
      </button>
    </>
  );
};
export default Archivos;
